export const WEBIM_CHAT = 'webim';
export const SENDER_CHAT = 'sender';
export const FRESH_CHAT = 'freshchat';
export const KWIZBOT = 'kwizbot';
export const ZENDESK_CHAT = 'zendesk';
